import React, { useEffect, useState } from "react";
import { Grid, Button } from "@material-ui/core";
import Controls from "../../../../controls/Controls";
import { useForm, Form } from "../../../../controls/useForm";

const initialFValues = {
  paymentType: "",
  customerName: "",
  accountId: 0,
  phoneNumber: "",
  paymentTypeId: 0,
  accountTypeId: 0,
  cardTypeId: 0,
};

export default function ProductForm(props) {
  const {
    addOrEdit,
    recordForEdit,
    accounts,
    accountTypes,
    cardtypes,
    paymentTypes,
  } = props;
  const [file, setFile] = useState(null);
  const validate = (fieldValues = values) => {
    let temp = { ...errors };

    setErrors({
      ...temp,
    });
    if (fieldValues === values)
      return Object.values(temp).every((x) => x === "");
  };

  var fileRecord = null;
  var state = {
    currentFile: undefined,
    previewImage: undefined,
    progress: 0,
    message: "",
    isError: false,
    imageInfos: [],
  };

  const { values, setValues, errors, setErrors, handleInputChange, resetForm } =
    useForm(initialFValues, true, validate);

  console.log("Credit Details", initialFValues);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validate()) {
      var data = { ...values, formFile: file };
      addOrEdit(data, resetForm);
    }
  };

  useEffect(() => {
    console.log(recordForEdit);
    if (recordForEdit !== null)
      setValues({
        ...recordForEdit,
      });
  }, [recordForEdit]);

  return (
    <Form onSubmit={handleSubmit}>
      <Grid container>
        <Grid item xs={6}>
          <Controls.Input
            name="paymentType"
            label="Payment Type"
            value={values.paymentType || ""}
            onChange={handleInputChange}
            readonly={true}
          />
          <Controls.Input
            label="Amount to Pay"
            name="amountOutsanding"
            value={values.amountOutstanding || ""}
            onChange={handleInputChange}
            readonly={true}
          />

          <Controls.Input
            label="Amount Paid"
            name="repaymentPlanId"
            value={values.amountPaid || ""}
            onChange={handleInputChange}
            readonly={true}
          />
          <Controls.Input
            name="customerName"
            label="Customer Name"
            value={values.name || ""}
            onChange={handleInputChange}
            readonly={true}
          />
        </Grid>
        <Grid item xs={6}>
          {/* <Controls.Input
            name="creditTenour"
            label="Credit Tenour"
            value={values.creditTenour || ''}
            onChange={handleInputChange}
            readonly={true}
          /> */}
          <Controls.Input
            name="date"
            label="Date"
            value={values.datePaid || ""}
            onChange={handleInputChange}
            readonly={true}
          />

          <Controls.Input
            label="Reference Number"
            name="referenceNumber"
            value={values.paymentFrequencyName || 0}
            onChange={handleInputChange}
            readonly={true}
          />
          <Controls.Input
            label="Reference Number"
            name="referenceNumber"
            value={values.referenceNumber || 0}
            onChange={handleInputChange}
            readonly={true}
          />
          <Controls.Input
            label="Transaction Reference"
            name="phoneNumber"
            value={values.transactionReference || ""}
            onChange={handleInputChange}
            readonly={true}
          />
        </Grid>
      </Grid>
    </Form>
  );
}
